export default {
  editWidth: 1400,
  editHeight: 873,
  postItemWidth: 130
}
